import httpClient from '@/core/http/client.service';

const searchPatient = (data) => httpClient.post('/api/v1/patient/search?_format=json', data);
const createPatient = (data) => httpClient.post('/api/v1/patient?_format=json', data);

export default {
  searchPatient,
  createPatient,
};
